import { render, staticRenderFns } from "./selectTopic.vue?vue&type=template&id=0046611c&scoped=true"
import script from "./selectTopic.vue?vue&type=script&lang=js"
export * from "./selectTopic.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=0046611c&prod&scoped=true&lang=css&external"
import style1 from "./selectTopic.vue?vue&type=style&index=1&id=0046611c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046611c",
  null
  
)

export default component.exports